module.exports = __webpack_public_path__ + "media/A_Ghost_Town.2d0ca518.mp3";